export const ArrowsRightIcon = (props: any) => {
    return (
        <svg {...props} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5 12H19M19 12L13 18M19 12L13 6" stroke="#1F1F1F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

    )
}

export const ArrowsLeftIcon = (props: any) => {
    return (
        <svg {...props} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19 12H5M5 12L11 18M5 12L11 6" stroke="#1F1F1F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

    )
}

export const ArrowPopoverIcon = (props: any) => {
    return (
        <svg {...props} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19.5615 7.40259C20.1194 6.8656 21.0237 6.8656 21.5816 7.40259C22.1395 7.93949 22.1395 8.80997 21.5816 9.34691L13.01 17.597C12.7421 17.8548 12.3789 17.9998 12 17.9998C11.6211 17.9998 11.2578 17.8548 10.9899 17.597L2.41836 9.34692C1.86055 8.80997 1.86055 7.93949 2.41836 7.40259C2.97627 6.8656 3.88057 6.8656 4.43848 7.40259L12 14.6805L19.5615 7.40259Z" fill="#1F1F1F" />
        </svg>
    )
}

export const ArrowUpRightIcon = (props: any) => {
    return (
        <svg {...props} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.71462 7.05026C7.71462 6.63605 8.05033 6.30034 8.46454 6.30034L16.9498 6.30034C17.364 6.30035 17.6997 6.63605 17.6997 7.05026L17.6997 15.5355C17.6997 15.9497 17.364 16.2855 16.9498 16.2855C16.5356 16.2855 16.1999 15.9497 16.1999 15.5355L16.1999 8.86084L7.58066 17.4801C7.28777 17.773 6.81289 17.773 6.52 17.4801C6.22711 17.1872 6.22711 16.7123 6.52 16.4194L15.1392 7.80018L8.46454 7.80018C8.05033 7.80017 7.71463 7.46447 7.71462 7.05026Z" fill="#1F1F1F" />
        </svg>
    )
}

export const ArrowRightWithoutCenterIcon = (props: any) => {
    return (
        <svg {...props} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.23432 5.22781C9.54674 4.92406 10.0532 4.92406 10.3656 5.22781L16.7657 11.4501C17.0781 11.7538 17.0781 12.2462 16.7657 12.5499L10.3656 18.7722C10.0532 19.0759 9.54674 19.0759 9.23432 18.7722C8.92189 18.4684 8.92189 17.9761 9.23432 17.6724L15.0688 12L9.23432 6.32764C8.92189 6.0239 8.92189 5.53155 9.23432 5.22781Z" fill="#1F1F1F" />
        </svg>

    )
}